import React from 'react';
import './App.css';
import { motion } from 'framer-motion';
import emailjs from 'emailjs-com';
import { useState } from 'react';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
  
    const formData = new FormData(e.target);
    console.log("Name:", formData.get("from_name"));
    console.log("Email:", formData.get("reply_to"));
    console.log("Message:", formData.get("message"));
  
    emailjs.sendForm('service_4y8shnu', 'template_39yjy8y', e.target, 'sq44ho7wx4CbMj7nZ')
      .then(() => {
        alert('Your message has been sent!');
      }, (error) => {
        console.error(error.text);
        alert('Something went wrong. Try again later.');
      });
  
    e.target.reset();
  };
  

  const services = [
    {
      title: "Swedish Massage",
      img: "https://backtobasicsamarillo.com/wp-content/uploads/2023/11/Unveiling-the-Various-Benefits-of-Swedish-Massage.jpg",
      desc: "Relax and unwind with a classic Swedish massage to improve circulation and flexibility."
    },
    {
      title: "Ayurvedic Massage",
      img: "https://th.bing.com/th/id/OIP.UpNv0QxblwFozFlqeR0c-AAAAA?rs=1&pid=ImgDetMain",
      desc: "A holistic treatment using traditional Indian techniques and oils."
    },
    {
      title: "Craniosacral Therapy",
      img: "https://th.bing.com/th/id/R.62d310af558aad91d2ddf2f4e7fd1115?rik=khx4vA%2fnU%2foLiQ&riu=http%3a%2f%2fbodymed.ie%2fwp-content%2fuploads%2f2016%2f10%2fCraniosacralTherapy1.jpg&ehk=0TG9WLXSV23MYPxYcm0Eoq8QVnI5OblTcxZmdY1fYUQ%3d&risl=&pid=ImgRaw&r=0",
      desc: "Rejuvenate your skin with essential oils and therapeutic techniques."
    }
  ];

  const testimonials = [
    {
      quote: "Good and very affordable charge",
      name: "Ranjith nantha",
      image: "https://tg-stockach.de/wp-content/uploads/2020/12/5f4d0f15338e20133dc69e95_dummy-profile-pic-300x300.png",
      rating: 5
    },
    {
      quote: "Nice massage and relaxing ambiance",
      name: "arun04",
      image: "https://tg-stockach.de/wp-content/uploads/2020/12/5f4d0f15338e20133dc69e95_dummy-profile-pic-300x300.png",
      rating: 5
    }
  ];

  return (
    <div className="font-sans text-gray-800">
      {/* Navbar */}
      <header className="bg-green-800 text-white pl-3 pr-6 lg:px-6 py-3.5 fixed top-0 w-full z-50 shadow-md">
      <div className="flex items-center justify-between">
        {/* Logo and title */}
        <div className="flex items-center gap-2 text-2xl font-bold">
          <img src="/logo.png" alt="Ayur Niketham Logo" className="w-10 h-10" />
          Ayur Niketham
        </div>

        {/* Hamburger menu for small screens */}
        <button
          className="md:hidden block focus:outline-none"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <svg
            className="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d={menuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
            />
          </svg>
        </button>

        {/* Desktop menu */}
        <nav className="hidden md:flex gap-6 text-lg">
          <a href="#about" className="hover:text-green-200">About</a>
          <a href="#services" className="hover:text-green-200">Services</a>
          <a href="#testimonials" className="hover:text-green-200">Testimonials</a>
          <a href="#contact" className="hover:text-green-200">Contact</a>
        </nav>
      </div>

      {/* Mobile dropdown menu */}
      {menuOpen && (
        <nav className="md:hidden mt-4 flex flex-col gap-4 text-lg">
          <a href="#about" onClick={() => setMenuOpen(false)} className="hover:text-green-200">About</a>
          <a href="#services" onClick={() => setMenuOpen(false)} className="hover:text-green-200">Services</a>
          <a href="#testimonials" onClick={() => setMenuOpen(false)} className="hover:text-green-200">Testimonials</a>
          <a href="#contact" onClick={() => setMenuOpen(false)} className="hover:text-green-200">Contact</a>
        </nav>
      )}
    </header>
 

{/* Hero Section */}
<section className="relative h-screen w-full overflow-hidden">
  {/* Background Image with zoom animation */}
  <motion.img
    initial={{ scale: 1.1, opacity: 0 }}
    animate={{ scale: 1, opacity: 0.85 }}
    transition={{ duration: 2 }}
    src="https://th.bing.com/th/id/OIP.3v0LQXGNTOdvMjFJccBWtwHaFZ?rs=1&pid=ImgDetMain"
    alt="Snaturals Spa Tranquil Room"
    className="w-full h-full object-cover"
  />

  {/* Overlay + Text */}
  <div className="absolute inset-0 bg-green-900 bg-opacity-40 flex flex-col items-center justify-center text-center px-4">
    {/* Main Title */}
    <motion.h1
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.2 }}
      className="text-white text-4xl md:text-7xl font-bold"
    >
      Welcome to <span className="text-green-200">Ayur Niketham Spa</span>
    </motion.h1>

    {/* Subheading */}
    <motion.p
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1, duration: 1 }}
      className="text-white text-xl md:text-2xl mt-4"
    >
      Discover Peace & Wellness in <span className="font-semibold">Palakkad</span>
    </motion.p>

    {/* CTA Button */}
    <motion.a
      href="#services"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.6, duration: 0.5 }}
      className="mt-8 px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-full text-lg shadow-lg"
    >
      Explore Our Treatments
    </motion.a>
  </div>
</section>

      {/* About Section */}
      <section id="about" className="bg-green-50 py-16 px-6 md:px-20">
        <h2 className="text-4xl font-bold text-green-800 mb-6 text-center">About Us</h2>
        <p className="text-lg text-center max-w-4xl mx-auto">
        Step into tranquility at Ayur Niketham Spa — where nature’s essence meets holistic healing. From soothing massages and aromatic therapies to revitalizing skin treatments, every service is crafted to restore your inner harmony. Surrounded by calming, eco-conscious spaces, we invite you to unwind, rejuvenate, and glow from within. Our expert therapists are dedicated to providing personalized care, ensuring each visit is a unique journey towards wellness. Experience the art of relaxation and let us guide you to a state of blissful serenity.
        </p>
      </section>

      {/* Services Section */}
      <section id="services" className="bg-white py-16 px-6 md:px-20">
        <h2 className="text-4xl font-bold text-green-800 mb-12 text-center">Our Spa Services</h2>
        <div className="grid gap-10 md:grid-cols-3">
          {services.map((service, index) => (
            <div key={index} className="rounded-lg overflow-hidden shadow-lg">
              <img src={service.img} alt={service.title} className="w-full h-60 object-cover" />
              <div className="p-6">
                <h3 className="text-2xl font-semibold text-green-700 mb-2">{service.title}</h3>
                <p>{service.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Testimonials */}
      <section id="testimonials" className="bg-green-100 py-16 px-6 md:px-20">
        <h2 className="text-4xl font-bold text-green-800 mb-12 text-center">Client Testimonials</h2>
        <div className="grid gap-10 md:grid-cols-2">
          {testimonials.map((testi, index) => (
            <div key={index} className="bg-white rounded-xl p-6 shadow flex gap-4 items-start">
              <img src={testi.image} alt={testi.name} className="w-14 h-14 rounded-full object-cover" />
              <div>
                <div className="flex items-center mb-2">
                  {[...Array(testi.rating)].map((_, i) => (
                    <svg key={i} className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.95a1 1 0 00.95.69h4.162c.969 0 1.371 1.24.588 1.81l-3.37 2.448a1 1 0 00-.364 1.118l1.287 3.95c.3.921-.755 1.688-1.538 1.118l-3.37-2.448a1 1 0 00-1.175 0l-3.37 2.448c-.783.57-1.838-.197-1.538-1.118l1.287-3.95a1 1 0 00-.364-1.118L2.075 9.377c-.783-.57-.38-1.81.588-1.81h4.162a1 1 0 00.95-.69l1.286-3.95z"/>
                    </svg>
                  ))}
                </div>
                <p className="italic text-lg">"{testi.quote}"</p>
                <p className="mt-2 font-semibold text-green-700">- {testi.name}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="bg-white py-16 px-6 md:px-20" netlify>
        <h2 className="text-4xl font-bold text-green-800 mb-8 text-center">Book Your Escape</h2>
        <form onSubmit={sendEmail} className="max-w-2xl mx-auto space-y-6">
          <input type="text" name="from_name" placeholder="Your Name" className="w-full border border-gray-300 p-4 rounded-lg" required />
          <input type="email" name="reply_to" placeholder="Your Email" className="w-full border border-gray-300 p-4 rounded-lg" required />
          <textarea name="message" rows="5" placeholder="Your Message" className="w-full border border-gray-300 p-4 rounded-lg" required></textarea>
          <button type="submit" className="bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-6 rounded-lg w-full">Submit</button>
        </form>
      </section>

      {/* Floating WhatsApp Icon */}
      <a
        href="https://wa.me/918848750677"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-10 mb-10 right-6 bg-green-500 p-4 rounded-full shadow-lg animate-bounce z-50"
      >
        <img src="https://cdn-icons-png.flaticon.com/512/124/124034.png" alt="WhatsApp" className="w-8 h-8" />
      </a>

      {/* Floating Call Button */}
      <a
        href="tel:+918848750677"
        className="fixed top-24 right-6 bg-green-600 hover:bg-green-700 text-white p-4 rounded-full shadow-lg z-50"
        title="Call Us"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h1.586a1 1 0 01.707.293l2.914 2.914a1 1 0 010 1.414L9.414 9.414a16.035 16.035 0 006.172 6.172l1.793-1.793a1 1 0 011.414 0l2.914 2.914a1 1 0 01.293.707V19a2 2 0 01-2 2h-1C7.82 21 3 16.18 3 10V7a2 2 0 012-2z" />
        </svg>
      </a>

      {/* Footer */}
      {/* Footer */}
      <footer className="bg-green-800 text-white py-6 text-center">
  <p>&copy; {new Date().getFullYear()} Ayur Niketham - Ayurvedic Spa. All rights reserved.</p>
  <p className="text-sm mt-2">Relaxation | Massage Therapy | Aromatherapy | Spa Treatments | Wellness</p>
  <div className="mt-4">
    <p className="text-lg">Contact Us:</p>
    <p>Near PTP petrol pump,11/153, Mamala, Thanavu, palakkad-kozhikode Rd, Palakkad, Kerala 678731</p>
    <p>Phone: <a href="tel:+918848750677" className="text-green-400 hover:text-green-500">9363636984</a></p>
    {/* <p>Email: <a href="mailto:sundharamsanmuga771@gmail.com" className="text-green-400 hover:text-green-500">sundharamsanmuga771@gmail.com</a></p> */}
  </div>
</footer>


    </div>
  );
}

export default App;
